export const Icon = {
    edit: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/edit.png',
    delete: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/delete.png',
    collapse: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/collapse.png',
    expand: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/expand.png',
    newQuestion: 'https://muzhi-public-pic.cdn.bcebos.com/100115321292',
    muzhiPc: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/muzhipc.png',
    logout: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/logout.png',
    login: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/login.png',
    rightArrow: 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/right.png',
    dot:'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/icon/dot.png',
}